module.exports = __webpack_public_path__ + "fonts/iconfont.8544b532.ttf";